import { put, select, take } from 'redux-saga/effects';
import { replace } from 'redux-little-router';
import { isNil } from 'lodash';
import * as selectors from '../selectors';
import * as actions from '../redux/actions';
import * as actionTypes from '../redux/actionTypes';
import { STEP_INITIAL } from '../constants';
import { getDraftByCardId } from './draftSagas';
import {
  actionTypes as getContactsActionTypes,
  startRequest as getContacts,
} from 'modules/Contacts/redux/contacts/actions';

/**
 *  Initialize light deduction scenario
 * @returns {IterableIterator<*>}
 */
export function* initializeSaga() {
  yield put(getContacts());
  yield take(getContactsActionTypes.REQUEST_SUCCESS);

  const cardId = yield select(selectors.getCardIdFromRouter);
  const step = yield select(selectors.getStepFromRouter);

  if (!isNil(cardId)) {
    yield getDraftByCardId({ cardId, step });
  } else {
    const draftMode = yield select(selectors.selectDraftMode);

    yield put(actions.getSavedDrafts(draftMode));
    yield take(actionTypes.GET_SAVED_DRAFTS_SUCCESS);
    yield put(replace({ query: { step: STEP_INITIAL } }));
  }

  return yield put(actions.initializeSuccess());
}
